const normalizeAltText = (value) =>
    String(value || '')
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, ' ')
        .trim();

const filenameStem = (label) =>
    normalizeAltText(
        String(label || '')
            .split(/[?#]/)[0]
            .replace(/\.[a-z0-9]{2,5}$/i, '')
    );

function getAltTextQualityIssues({ altText, label, duplicateCount = 1 }) {
    const value = String(altText || '').trim();
    if (!value) return [];

    const issues = [];
    const normalizedValue = normalizeAltText(value);
    if (value.length < 10) {
        issues.push({ code: 'short', label: 'Very short alt text' });
    }
    if (value.length > 125) {
        issues.push({ code: 'long', label: 'Over 125 characters' });
    }
    if (duplicateCount > 1) {
        issues.push({ code: 'duplicate', label: 'Repeated alt text' });
    }
    if (normalizedValue && normalizedValue === filenameStem(label)) {
        issues.push({ code: 'filename', label: 'Alt text is the filename' });
    }
    if (/^(image|picture|photo|photograph|graphic)\s+of\b/i.test(value)) {
        issues.push({ code: 'redundant', label: 'Avoid “image of”' });
    }

    return issues;
}

module.exports = {
    getAltTextQualityIssues,
    normalizeAltText,
};
